import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=7e508290&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e508290')) {
      api.createRecord('7e508290', component.options)
    } else {
      api.reload('7e508290', component.options)
    }
    module.hot.accept("./Preview.vue?vue&type=template&id=7e508290&", function () {
      api.rerender('7e508290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Preview.vue"
export default component.exports